import * as React from 'react'
import { Umbrella } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-MEALS`

interface IProps {
  breakfast: boolean | null
  dinner: boolean | null
  lunch: boolean | null
}

export default function Meals(props: IProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const mealsOffered = [
    props.breakfast ? t(`${PRE}-BREAKFAST`) : '',
    props.lunch ? t(`${PRE}-LUNCH`) : '',
    props.dinner ? t(`${PRE}-DINNER`) : '',
  ].filter(x => x)

  if (!mealsOffered.length) return null

  return (
    <Bullet icon={<Umbrella style={{ transform: 'rotate(180deg)' }} />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{toCommaSeperatedStringWithAnd(mealsOffered)}</Text>
    </Bullet>
  )
}

// https://stackoverflow.com/a/16251861
function toCommaSeperatedStringWithAnd(array: string[]): string {
  return [array.slice(0, -1).join(', '), array.slice(-1)[0]].join(array.length < 2 ? '' : ' and ')
}
